import React from 'react';
import { Segment } from 'semantic-ui-react';

const PersonNew = props => {
  return (
    <Segment textAlign="center">
      <button type="button" className="ui button primary" onClick={() => props.onClick()}>
        Create Contact
      </button>
    </Segment>
  );
};

export default PersonNew;
